/**
 * Shared types + labels for the client-side lead-fact suggestion pipeline.
 * See ./suggestions.ts for the flow.
 */

import type { EMessageDirection } from 'src/services/api/messages/types';

export type FactSource = 'rule' | 'llm' | 'stored';

export type IFactSuggestion = {
    key: string;
    value: string;
    label: string;
    source: FactSource;
};

/** Suggestion key -> human-readable label shown in the nudge. */
export const FACT_LABELS: Record<string, string> = {
    phone_number: 'Phone number',
    email: 'Email',
    pet_type: 'Pet',
    has_pet: 'Has a pet',
    monthly_income: 'Monthly income',
    annual_income: 'Annual income',
    household_size: 'Household size',
    voucher_type: 'Voucher type',
};

/** A conversation message reduced to what detection needs. */
export type SpeakerMessage = {
    direction: EMessageDirection;
    contents: string;
};

/** Fact fields the LLM extracts (each may be null in a given response). */
export const LLM_FIELDS = ['monthly_income', 'annual_income', 'household_size', 'voucher_type'] as const;
